import { theme } from "../../theme";
import { PortalLink } from "../../components/PortalLink";

// The CIS hardening line under an asset in the register: "Covered by <benchmark>"
// when a subscribed benchmark applies to it, "CIS benchmark available" (or "may
// apply" when only the asset's kind suggests it) linking to the hardening page
// when an applicable one is not subscribed. Data: GET /hardening/asset-coverage.

export interface AssetCoverageRef { benchmarkId: string; name: string; confidence: "confirmed" | "unconfirmed" }
export interface AssetCoverage { covered: AssetCoverageRef[]; available: AssetCoverageRef[] }
export type AssetCoverageMap = Record<string, AssetCoverage>;

const names = (refs: AssetCoverageRef[]) => refs.map((r) => r.name).join(", ");

export function AssetHardeningNote({ coverage }: { coverage: AssetCoverage }) {
  if (coverage.covered.length) {
    const more = coverage.available.length;
    return (
      <span style={{ color: theme.color.successText }} title={more ? `Also available: ${names(coverage.available)}` : undefined}>
        Covered by {names(coverage.covered)}{more ? <> · <PortalLink to="/hardening" style={{ color: theme.color.accentText }}>{more} more available</PortalLink></> : null}
      </span>
    );
  }
  if (!coverage.available.length) return null;
  const confirmed = coverage.available.some((r) => r.confidence === "confirmed");
  return (
    <PortalLink to="/hardening" style={{ color: theme.color.accentText }} title={names(coverage.available)}>
      CIS benchmark {confirmed ? "available" : "may apply"}{coverage.available.length > 1 ? ` (${coverage.available.length})` : ""}
    </PortalLink>
  );
}
